import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=bd853b90&scoped=true&"
import script from "./Nav.vue?vue&type=script&lang=js&"
export * from "./Nav.vue?vue&type=script&lang=js&"
import style0 from "./Nav.vue?vue&type=style&index=0&id=bd853b90&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd853b90",
  null
  
)

export default component.exports